var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.href)?_c('a',{class:['base-button', _vm.styleButton, _vm.size],attrs:{"href":_vm.href,"disabled":_vm.isDisabled}},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_c('button',{class:['base-button', _vm.styleButton, _vm.size],attrs:{"disabled":_vm.isDisabled}},[_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }